module.exports = __webpack_public_path__ + "img/trophy-awards.d5e2e525.svg";